/**
 * OLD PLANNER (DEPRECATED) - OldTaskCrewPlannerPage.jsx
 * 
 * EF-PLANNER-DEPRECATION-AND-RENAMING-V1:
 * This planner is deprecated in favor of SheetCrewPlannerPage (/planner/sheet).
 * Route /task-crew-planner now redirects to /planner/sheet.
 * This file is kept only for historical reference and debug purposes.
 * Access via hidden route /old-planner only.
 * 
 * Original Description (DEPRECATED):
 * Shift Crew Planner — Multi-Day Columnar View
 * Based on uTrac reference layout.
 */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// ============================================================
// MAIN COMPONENT - OLD Planner (Deprecated)
// ============================================================
export default function OldTaskCrewPlannerPage() {
  const navigate = useNavigate();
  
  // EF-PLANNER-DEPRECATION-AND-RENAMING-V1: Log access to old planner
  useEffect(() => {
    console.log("[OLD PLANNER REDIRECTED] Accessing deprecated OLD PLANNER - redirecting to new Crew Planner");
    // Auto-redirect to new planner after 3 seconds
    const timer = setTimeout(() => {
      navigate('/planner/sheet', { replace: true });
    }, 3000);
    return () => clearTimeout(timer);
  }, [navigate]);
  
  // EF-PLANNER-DEPRECATION-AND-RENAMING-V1: Show deprecation UI
  return (
    <div className="h-screen flex flex-col items-center justify-center bg-surface-base p-8">
      <div className="max-w-md text-center space-y-6">
        <div className="text-6xl mb-4">⚠️</div>
        <div className="text-lg font-semibold text-amber-600 uppercase tracking-wider">
          Planner: OLD (Deprecated)
        </div>
        <h1 className="text-2xl font-bold text-foreground">
          OLD PLANNER (DEPRECATED)
        </h1>
        <p className="text-muted-foreground">
          This planner is no longer in use.
        </p>
        <p className="text-muted-foreground">
          Redirecting to new Crew Planner...
        </p>
        <div className="pt-4">
          <button
            onClick={() => navigate('/planner/sheet', { replace: true })}
            className="px-6 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors"
            data-testid="redirect-to-new-planner"
          >
            Go to Crew Planner Now
          </button>
        </div>
      </div>
    </div>
  );
}
